<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AddVotersGroup />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AddVotersGroup from "./components/AddVotersGroup";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Add Voters Group",
  components: {
    AddVotersGroup,
    // ProjectsTable,
  },
};
</script>
